import React, { useState } from 'react';
import { styled } from '@compiled/react';
import Button from '@atlaskit/button/custom-theme-button';
import InformationIcon from '@atlaskit/icon/utility/information';
import Popup from '@atlaskit/popup';
import { token } from '@atlaskit/tokens';
import { injectIntlV2 as injectIntl } from '@atlassian/jira-intl/src/v2/inject.tsx';
import type { Props } from '../types';
import messages from './messages';

export const RecalculationWarning = ({ data, loading, error, intl: { formatMessage } }: Props) => {
	const [isOpen, setIsOpen] = useState(false);

	if (!loading && !error && data && data.shouldWarn === true) {
		return null;
	}

	const toggleOpenDialog = () => {
		setIsOpen((prev) => !prev);
	};

	return (
		<WarningContainer>
			<Popup
				isOpen={isOpen}
				onClose={toggleOpenDialog}
				placement="bottom-start"
				autoFocus={false}
				content={() => (
					<WarningDialogBox>
						{formatMessage(messages.reCalculationCostWarningInfoMessage)}
					</WarningDialogBox>
				)}
				trigger={(triggerProps) => (
					<Button
						{...triggerProps}
						onClick={toggleOpenDialog}
						spacing="none"
						appearance="subtle-link"
					>
						<IconMessageWrapper>
							{}
							<InformationIcon LEGACY_primaryColor="N200" label="" color="currentColor" />
							<WarningLabel>{formatMessage(messages.reCalculationCostLabel)}</WarningLabel>
						</IconMessageWrapper>
					</Button>
				)}
			/>
		</WarningContainer>
	);
};

export const RecalculationWarningInfo = injectIntl(RecalculationWarning);

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const WarningDialogBox = styled.div({
	maxWidth: '218px',
	padding: token('space.200', '16px'),
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const IconMessageWrapper = styled.div({
	display: 'flex',
	alignItems: 'center',
	paddingRight: token('space.100', '8px'),
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const WarningContainer = styled.div({
	marginRight: token('space.100', '8px'),
	display: 'flex',
	marginBottom: token('space.050', '4px'),
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const WarningLabel = styled.div({
	marginLeft: token('space.050', '4px'),
});
